import React, { Fragment, useEffect, useState } from 'react'
import AddComponent from '../../../components/AddComponent'
import { CheckBadgeIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid'
import LinkButton from '../../helpers/LinkButton'
import Table from '../../helpers/Table'
import Loader from '../../Common/Loader'
import { Link, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import flasher from '@flasher/flasher'
import ActionButton from '../../helpers/ActionButton'
import { AddCircle, Check } from 'iconsax-react'
import DataNotFound from '../../helpers/DataNotFound'
import { DeleteGladianceDepartment, GetGladianceDepartmentList } from '../../../Encapsulation/GladianceDomainEntities/GladianceDepartment'
import Pagination from '../../helpers/Pagination'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function GladianceDepartmentMaster({ Rights }) {
    document.title = 'Gladiance - Departments'
    let tableHeading = ['Sr.No', 'Department Name', 'Action']
    // tableHeading = tableHeading.filter((data) => data != 'Action' || (data == 'Action' && Rights.Delete))
    tableHeading = tableHeading.filter((data) => (Rights.View == false ? data != 'Action' : data))
    const location = useLocation()
    console.log('location :', location);
    const [loader, setLoader] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 7;
    const [gladianceDepartmentMasterList, setGladianceDepartmentMasterList] = useState([])
    const fetchDepartmentList = async () => {
        setGladianceDepartmentMasterList(await GetGladianceDepartmentList());
    }

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const deleteGladianceDepartment = (tableData) => {
        Swal.fire({
            title: 'Are you sure to delete this?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                let response = await DeleteGladianceDepartment(tableData)
                if (response.Successful == false) {
                    flasher.warning(response.Message)
                } else {
                    flasher.error('Deleted Successfully', 'Deleted', <CheckBadgeIcon variant='Bold' className='w-5 h-5' />)
                    fetchDepartmentList();
                }
            }
        })
    }

    const currentpage = () => {
        location && setCurrentPage(location.state)
    }

    useEffect(() => {
        fetchDepartmentList();
        if(location.state){
            currentpage()
        }
    }, [])

    return (
        <Fragment>
            {loader ? (<Loader />) : (
                <AddComponent title={'Departments'} button={
                    <LinkButton to={Rights.Add && ('/gladiance-department-master/add-gladiance-department-master')} state={{currentPage}} className={Rights.Add ? 'opacity-100' : 'hidden'} >
                        <AddCircle variant='Bold' className='w-5 h-5' />
                        <span>Add Department</span>
                    </LinkButton>
                }>
                    {gladianceDepartmentMasterList && gladianceDepartmentMasterList.length > 0 ? (
                        <div className='m-2'>
                            <Table tableHeading={tableHeading}>
                                {gladianceDepartmentMasterList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((tableData, tableDataID) => {
                                    return (
                                        <Fragment key={tableDataID}>
                                            <tr className="border-b border-opacity-30 border-white">
                                                <td className="px-4 py-3">{tableDataID + 1}</td>
                                                <td className="px-4 py-3">{tableData.Name}</td>
                                                {
                                                    (Rights.View) && (
                                                        <td className="px-4 py-3">
                                                            <div className='flex justify-center gap-3'>
                                                                {
                                                                    (Rights.Edit || Rights.View) && (
                                                                        <Link to={`/gladiance-department-master/edit-gladiance-department-master/${tableData.Ref}`} title='Edit' state={{currentPage}} >
                                                                            <ActionButton className={'p-1.5 text-white bg-yellow-400 '}>
                                                                                <PencilSquareIcon className='w-4 h-4' />
                                                                            </ActionButton>
                                                                        </Link>
                                                                    )
                                                                }
                                                                {
                                                                    Rights.Delete && (
                                                                        <ActionButton onClick={() => deleteGladianceDepartment(tableData)} title={'Delete'} className='p-1.5 text-white bg-red-600 rounded-lg cursor-pointer'>
                                                                            <TrashIcon className='w-4 h-4' />
                                                                        </ActionButton>
                                                                    )
                                                                }

                                                            </div>
                                                        </td>
                                                    )
                                                }

                                            </tr>
                                        </Fragment>
                                    )
                                })}
                            </Table>
                        </div>
                    ) : (
                        <DataNotFound labelText={'Sorry! Departments Data Not Found'} />
                    )}
                    {gladianceDepartmentMasterList && gladianceDepartmentMasterList.length > 7 ? (<div className="flex justify-end">
                        <Pagination
                            itemsPerPage={itemsPerPage}
                            totalItems={gladianceDepartmentMasterList.length}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        />
                    </div>) : (<div></div>)
                    }
                </AddComponent>
            )}
        </Fragment>
    )
}
export default GladianceDepartmentMaster